import firebase from "firebase/app";
import "firebase/firestore";

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyB0bvSjFb-3Y5VVPoChGTn0Y6mM4cNi284",
  authDomain: "formularios-ergosolar.firebaseapp.com",
  databaseURL: "https://formularios-ergosolar.firebaseio.com",
  projectId: "formularios-ergosolar",
  storageBucket: "formularios-ergosolar.appspot.com",
  messagingSenderId: "130361334452",
  appId: "1:130361334452:web:759acc3ed05647ea8d95e1",
  measurementId: "G-3CZHXM34RJ",
};
// Initialize Firebase
const fb = firebase.initializeApp(firebaseConfig);

export const db = fb.firestore();
